const getFormData = require('get-form-data');
const isMobile = require('is-mobile');
const Filters = (function() {

  function Filters(url, form) {
    this.form = form;
    this.url = url;

    addFilterEvents.call(this);
  }

  Filters.prototype.getFilters = function() {
    return getFormData(this.form[0]);
  };

  Filters.prototype.before = function() {};

  Filters.prototype.after = function(html) {};

  Filters.prototype.filterData = function() {
    const _this = this;
    const url = this.url;

    if (url.name === 'app.despesas.filtrar') {
      const tipoDespesa = document.getElementById('idDespesaTipo').value
      const pagamentoForma = document.getElementById('idPagamentoFormas').value
      if ((!tipoDespesa && !localStorage['despesaTipo'])
        || !pagamentoForma && !localStorage['pagamentoForma']) {
        localStorage['despesaTipo'] = '-1'
        localStorage['pagamentoForma'] = '-1'
        return false
      }

      if (localStorage['despesaTipo'] !== '-1' || tipoDespesa) {
        localStorage['despesaTipo'] = tipoDespesa;
      }

      if (localStorage['pagamentoForma'] !== '-1' || pagamentoForma) {
        localStorage['pagamentoForma'] = pagamentoForma
      }
    }

    _this.before();

    return $.post(url, this.getFilters(), function(html) {
      const inputClear = document.querySelector('.clear');
      if (inputClear !== null) {
        inputClear.value = '';
      }
      _this.after(html);
    });

  };

  const addFilterEvents = function() {
    const _this = this;
    if (!isMobile()) {
      _this.form.find('#search')
        .bindWithDelay('keyup', function() {
          _this.filterData();
        }, 1250);
      _this.form.find(':input:not(#search)')
        .bindWithDelay('change', function() {
          _this.filterData();
        }, 1250);
    } else {
      _this.form.on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        _this.filterData();
      });
    }
  };

  return Filters;
}());

module.exports = Filters;
